import { resourceGetExternalsConfig } from '../../api/resources';

const state = {
    configuration: [],
    isLoaded: false,
};

const mutations = {
    SET_CONFIG: (state, config) => {
        state.configuration = config;
        state.isLoaded = true;
    },
};

const actions = {
    loadExternalsConfiguration({ state, commit }) {
        if (state.isLoaded) {
            return Promise.resolve();
        }

        return resourceGetExternalsConfig()
            .then(({ data }) => {
                commit('SET_CONFIG', data);
            })
            .catch(error => {
                commit('SET_CONFIG', []);

                return Promise.reject(error);
            });
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
